<template>
  <v-container
    fluid
  >
    <v-form>
      <v-container>
        <v-btn
          class="ma-2 float-left"
          tile
          outlined
          :loading="btnLoading"
          :disabled="btnLoading"
          color="success"
          @click="save()"
        >
          <v-icon
            left
          >
            mdi-check
          </v-icon>
          {{ $t('save') }}
        </v-btn>
        <v-subheader
          class="display-1"
        >
          {{ $t('operations_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="PagesCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template
                  v-slot:append
                >
                  <v-text-field
                    v-model="PagesCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="pagesValue"
                :items="pagesItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings',
    data: () => ({
      btnLoading: false,
      valid: false,
      PagesCPP: 0,
      min: 1,
      max: 100,
      pagesItems: [],
      pagesValue: [],
      snackbar: false,
      snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
      snackbarText: '',
    }),
    async created () {
      await this.getOptions()
      await this.getPagesColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showLikeTitle', {
          title: 'Pages',
        }).then(
          response => {
            const result = response.data.Option
            this.PagesCPP = parseInt(result.find(x => x.title === 'Pages-CPP').value)
            const tempValue = result.filter(x => x.title === 'Pages-TH-Operations')
            const tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.pagesValue = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getPagesColumns () {
        this.$http.post('pages/columns').then(
          response => {
            const result = response.data.PagesColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({
                dbitem: value,
                display: self.$t(value),
              })
            })
            this.pagesItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': pages/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': pages/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoading = true
        const temparray = []
        this.pagesValue.forEach(o => {
          temparray.push({ title: 'Pages-TH-Operations', value: o, language_id: 1 })
        })
        this.$http.post('options/destroyAndInsertByTitle', {
          title: ['Pages-TH-Operations'],
          insertArray: temparray,
        }).then(
          response => {
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_updated')
            this.snackbar = true
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|902'
          this.snackbar = true
          console.log(error)
        })
        this.btnLoading = false
        // TODO: Save PagesCategoriesColumns and Other
      },
    },
  }
</script>

<style scoped>

</style>
